function previewFile(file) {
  if (!file) {
    return ''
  }
  if (file.startsWith('http')) {
    return file
  }
  if (file.startsWith('uploads/')) {
    return process.env.VUE_APP_API_URL +  '/' +  file
  }
  return file
}

export { previewFile }
